import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { TranslateModule } from '@ngx-translate/core';
import { AvEmptyStateComponent } from '../../../../Shared/Components/av-empty-state/av-empty-state.component';
import { AvPaginatorComponent } from '../../../../Shared/Components/av-paginator/av-paginator.component';
import { AvStatusChipComponent } from '../../../../Shared/Components/av-status-chip/av-status-chip.component';
import { RbacFacade } from '../../../../../Facades/Rbac/rbac.facade';
import { VALUE_UNRESOLVED } from '../../../../../Consts/backoffice.const';

@Component({
  selector: 'app-rbac',
  standalone: true,
  imports: [
    ReactiveFormsModule,
    MatIconModule,
    MatTooltipModule,
    TranslateModule,
    AvEmptyStateComponent,
    AvPaginatorComponent,
    AvStatusChipComponent,
  ],
  templateUrl: './rbac.component.html',
  styleUrl: './rbac.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: { class: 'd-block' },
})
export class RbacComponent {
  private readonly _formBuilder = inject(FormBuilder);

  readonly facade = inject(RbacFacade);

  readonly unresolved = VALUE_UNRESOLVED;

  readonly formGroup: FormGroup = this._formBuilder.group({ search: [''] });

  submit(): void {
    if (!this.formGroup.valid) {
      return;
    }

    this.facade.applySearch(String(this.formGroup.value.search ?? '').trim());
  }

  reset(): void {
    this.formGroup.reset({ search: '' });
    this.facade.applySearch('');
  }

  selectRole(roleId: string): void {
    this.facade.selectRole(roleId);
  }

  goToPage(page: number): void {
    this.facade.goToPage(page);
  }

  changePageSize(pageSize: number): void {
    this.facade.changePageSize(pageSize);
  }
}
